import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { useLayoutLanguage } from '../context/LayoutLanguageContext';
import { useProductLanguage } from "../context/ProductLanguageContext";
import { useOutsideClick } from "../utils/utils";
import {useAppNavigation} from "../hooks/useAppNavigation";
import Modal from '../components/Modal';
import useModal from '../hooks/useModal';
import HamburgerIcon from '../assets/images/hamburger-icon.svg';


const HamburgerMenu = () => {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    const { layoutT } = useLayoutLanguage(); 
    const {t:productT } = useProductLanguage();

    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    const { isModalVisible, modalContent, openModal, closeModal } = useModal();

    const { goToApplications, isProduct } = useAppNavigation();

    const toggleMenu = () => {

     // console.log("isOpen is: ", isOpen);
      setIsOpen(!isOpen);
    };

    useOutsideClick(menuRef, () => setIsOpen(false));

    const handleLogout = () => {
      instance.logoutRedirect({
        postLogoutRedirectUri: window.location.origin,
      }).catch(e => {
        console.error(e);
      });
    };
  

    const handleLinkClick = (e) => {
        setIsOpen(!isOpen);

         e.preventDefault();
         openModal(
          layoutT('confirmation'),
          layoutT('confirmation_text'),
         );
    };

    const externalLink = "https://www.hugoassurance.ca/guides-et-documents"; 
     
    const handleInfo = (e) => {
        e.preventDefault();
        window.open(externalLink, '_blank');
        setIsOpen(false);
    };
  
    return (
        <>
        { isAuthenticated && (
          <div className="hamburger-menu" ref={menuRef}>
              <button title="hamburger-button" className={`hamburger-button ${isOpen ? 'hamburger-button-open' : ''}`} onClick={toggleMenu}>
                  <img src={HamburgerIcon} alt="Hamburger Icon" width={32} height={26} />

              </button>
              <div className={`hamburger-dropdown-menu ${isOpen ? 'hamburger-open' : 'hamburger-closed'}`}>
                  {isProduct && (
                    <>
                      <a href="#" className="hamburger-menu-item" onClick={handleInfo}>  {layoutT('need_information')} </a>
                      <Link to="#" onClick={handleLinkClick} className="hamburger-menu-item">
                          {layoutT('suspend_application')}
                      </Link>
                    </>
                  )}
                  <a href="#" className="hamburger-menu-item" onClick={handleLogout}>{layoutT('disconnect')}</a>
              </div>
          </div>
        )}

<Modal
        isVisible={isModalVisible}
        title={modalContent.title}
        content={modalContent.content}
        onClose={closeModal}
        actions={
          <>
            <button onClick={() => {
              goToApplications();
              closeModal();
            }} className="btn-purple">
              {productT('yes')}
            </button>
            <button onClick={closeModal} className="btn-purple">
              {productT('no')}
            </button>
          </>
        }
      />
      </>
    );
};
  
export default HamburgerMenu;
